const downloadFile = (base64String, filename) => {
  // Decode base64 string
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob from the binary data
  const blob = new Blob([bytes], { type: "application/pdf" });

  // Create a link element
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename; // Specify the filename

  // Programmatically click the link to trigger the download
  document.body.appendChild(link);
  link.click();

  // Cleanup: remove the link from the DOM
  document.body.removeChild(link);
};

export default downloadFile;
